import type { FC } from "react";
import { Feature } from "@viagogo/feature";
import { FeatureSetEnum } from "src/shared/constants/FeatureSetEnum";
import type { Dates } from "src/types/shared/cookies";
import { branch } from "src/website-apps/shared/components/branch";
import { withDefaultContexts } from "src/website-apps/shared/components/explore/withDefaultContexts";
import { withExploreContexts } from "src/website-apps/shared/components/explore/withExploreContexts";
import { withExploreExp } from "src/website-apps/shared/components/explore/withExploreExp";
import { VenueLayoutV1 } from "./VenueLayoutV1/VenueLayoutV1";
import { VenueLayoutV2 } from "./VenueLayoutV2/VenueLayoutV2";

interface Props {
  dates?: Maybe<Dates>;
}

const UnwrappedApp: FC<Props> = ({ dates }) => (
  <Feature
    id={FeatureSetEnum.TMVenueDiscoveryVenueImprovementsV2}
    control={() => <VenueLayoutV1 dates={dates} />}
    variant={() => <VenueLayoutV2 dates={dates} />}
  />
);

const ExploreExpApp = branch(
  (props: Props & { exploreEnabled?: Maybe<boolean> }) => !!props.exploreEnabled,
  withExploreContexts,
  withDefaultContexts,
)(UnwrappedApp);
export const App = withExploreExp(ExploreExpApp);
